export const studentInterests = [
  "Academic Decathlon",
  "Astrology",
  "Backpacking",
  "Baseball",
  "Basketball",
  "Board games",
  "Books",
  "Camping",
  "Cars",
  "Coding",
  "Cooking/Baking",
  "Country music",
  "Crafting",
  "Cycling",
  "Dance",
  "Design",
  "Destination ImagiNation",
  "Disney",
  "EDM",
  "Faith/Religion",
  "Fashion/Beauty",
  "FIRST Robotics",
  "Fishing/Hunting",
  "Fitness",
  "Food",
  "Football",
  "Greek life",
  "Hiking",
  "Hip-hop/Rap",
  "Hockey",
  "Jazz",
  "Journaling",
  "K-Pop",
  "Learning languages",
  "LGBTQ inclusion",
  "Making music",
  "Martial arts/MMA",
  "Movies",
  "MUN",
  "Musicals",
  "Netflix",
  "Partying",
  "Philosophy",
  "Photography",
  "Plants",
  "Playing sports",
  "Podcasts",
  "Politics",
  "Quiz Bowl",
  "R&B",
  "Rock climbing",
  "Running",
  "Sci-Fi",
  "Science Olympiad",
  "Singing",
  "Skateboarding/BMX",
  "Soccer",
  "Social justice issues",
  "Speech and debate",
  "Student government",
  "Studying abroad",
  "Swimming",
  "Theater",
  "Travel",
  "Ultimate",
  "Video games",
  "Visual arts",
  "Volunteering",
  "Water sports",
  "Winter sports",
  "Writing",
  "Yoga",
  "YouTube",
  "3D Modeling",
  "3D Printing",
  "Aeronautics",
  "Aerospace",
  "Anatomy",
  "Animation",
  "Archery",
  "Architecture",
  "Autoracing",
  "Aviation",
  "Baking",
  "Ballroom dance",
  "Beachcombing",
  "Beauty",
  "Black Lives Matter",
  "BMX",
  "Braiding hair",
  "Building computers",
  "Business",
  "C-Pop",
  "Card games",
  "Cats",
  "Cheer",
  "Chess",
  "Classical studies",
  "Clogging",
  "CNC machining",
  "Coffee",
  "Color Guard",
  "Comics",
  "Computer sciences",
  "Computers",
  "Content creation",
  "Cricket",
  "Criminal justice",
  "Crocheting",
  "Cross country",
  "Culture",
  "Cyber security",
  "Digital editing",
  "Dirt Biking",
  "Disc Golf",
  "Disney+",
  "Drill Team",
  "Driving",
  "Drones",
  "Dungeons & Dragons",
  "Anime 🦄",
  "Concerts/Music festivals 🎵",
  "Fantasy films/novels 🎥",
  "Farming/Agriculture 🌾",
  "Environmental activism 🌏",
  "Entrepreneurship 😎",
  "Business Management 💼",
  "Eating",
  "Engineering",
  "Equestrian",
  "eSports",
  "Fencing",
  "Figure skating",
  "Filmmaking",
  "Finance",
  "Fishing",
  "Flying",
  "Forensics",
  "Golf",
  "Graphic design",
  "Gymnastics",
  "Heavy metal",
  "Historical fiction",
  "History",
  "Horseback riding",
  "Ice skating",
  "Indian music",
  "Interior design",
  "Internships",
  "Journalism",
  "K/C/J dramas",
  "Karate",
  "Kayaking",
  "Knitting",
  "LEGO",
  "Magic",
  "Making beats",
  "Manga",
  "Maple syrup tapping",
  "Marching band",
  "Mathematics",
  "Metal",
  "MMA",
  "Motorcycles",
  "Music",
  "Music festivals",
  "Mycology",
  "Netball",
  "Nursing",
  "Orchestra",
  "Paintball",
  "Physics",
  "Poetry",
  "Pokémon",
  "Police Explorers",
  "Pop music",
  "Pop punk",
  "Powerlifting",
  "Psychedelic rock",
  "Psychology",
  "Public Policy",
  "Quidditch",
  "RC Racing",
  "Reading novels",
  "Religion",
  "Renaissance Faires",
  "Robotics",
  "Rock music",
  "Roller coasters",
  "Science",
  "Scuba diving",
  "Shopping",
  "Skiing",
  "Sociology",
  "Songwriting",
  "Space exploration",
  "STEM",
  "Stepping",
  "Styling",
  "Surfing",
  "Tabletop Gaming",
  "Teaching",
  "Technology",
  "Thrash metal",
  "Track and field",
  "USMC ROTC",
  "VEX Robotics",
  "Walking",
  "Weather",
  "Weightlifting",
  "Witchcraft",
  "Woodworking",
  "Yoyo",
  "2000's Pop music 🎵",
  "Cheer/Dance/Step team 🕺🏼",
  "Down Syndrome",
];
